import { mainpageReducer } from './mainpage';
import { configReducer } from './modules/config/config';
import { userGeoReducer } from './modules/search/user_geo';

export const oldReducers = {
  config: configReducer,
  userGeo: userGeoReducer,
  mainpage: mainpageReducer,
};
